import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { faLinkedin, faGithub } from "@fortawesome/free-brands-svg-icons";
import lightPhoto from "../assets/headshot.jpg";

export default function About({ theme }) {
  return (
    <section className="relative max-w-[2000px] mx-auto">
      <div 
        className={`
          relative flex items-center px-10 py-24 mx-auto
          flex-col lg:flex-row lg:items-center
          ${theme === 'dark' 
            ? 'bg-black' 
            : 'bg-gradient-to-b from-white via-white to-[#c0dfd9]'
          }
        `}
        id="about"
      >
        <div className="flex-[2] inline-block align-top text-center p-5 max-w-md lg:max-w-none">
          <img 
            src={lightPhoto}
            alt="" 
            className={`
              w-4/5 h-auto rounded-full mx-auto
              ${theme === 'dark' 
                ? 'shadow-[5px_4px_10px_#f7f7f7] grayscale' 
                : 'shadow-[0px_5px_10px_#b3c2bf]'
              }
            `}
          />
        </div>
        
        <div className="flex-[3] inline-block align-top">
          <h1 className={`
            font-['Rubik'] mb-2 font-black text-4xl lg:text-5xl
            ${theme === 'dark' ? 'text-[#f7f7f7]' : 'text-[#3b3a36]'}
            text-center lg:text-left
          `}>
            About Me
          </h1>
          
          <p className={`
            font-['Roboto_Mono'] leading-relaxed text-center lg:text-left
            ${theme === 'dark' ? 'text-[#f7f7f7]' : 'text-[#3b3a36]'}
          `}>
            I am a Full-Stack Developer at Rotowire.com living in eastern Pennsylvania.
          </p>
          
          <br />
          
          <p className={`
            font-['Roboto_Mono'] leading-relaxed text-center lg:text-left
            ${theme === 'dark' ? 'text-[#f7f7f7]' : 'text-[#3b3a36]'}
          `}>
            I have music and philosophy degrees from Ithaca College.
          </p>
          
          <br />
          
                    
          <p className={`
            font-['Roboto_Mono'] leading-relaxed text-center lg:text-left
            ${theme === 'dark' ? 'text-[#f7f7f7]' : 'text-[#3b3a36]'}
          `}>
            In my spare time, I enjoy acting, theater, escape rooms, and strategy games of <span class="whitespace-nowrap">all sorts.</span>
          </p>
          <br />

          <p className={`
            font-['Roboto_Mono'] leading-relaxed text-center lg:text-left
            ${theme === 'dark' ? 'text-[#f7f7f7]' : 'text-[#3b3a36]'}
          `}>
            Thank you for visiting!
          </p>
          
          <div className="mt-2 text-center lg:text-left">
            <a
              href="https://www.linkedin.com/in/michaelradzwilla/"
              target="_blank"
              rel="noopener noreferrer"
              className={`
                inline-block mr-2.5 ml-0.5 text-3xl transition-transform duration-300 align-top
                ${theme === 'dark' ? 'text-[#f7f7f7]' : 'text-[#3b3a36]'}
              `}
            >
              <FontAwesomeIcon icon={faLinkedin} alt="Linkedin" />
            </a>
            <a
              href="https://github.com/mradzwilla"
              target="_blank"
              rel="noopener noreferrer"
              className={`
                inline-block mr-2.5 ml-0.5 text-3xl transition-transform duration-300 align-top
                ${theme === 'dark' ? 'text-[#f7f7f7]' : 'text-[#3b3a36]'}
              `}
            >
              <FontAwesomeIcon icon={faGithub} alt="Github" />
            </a>
            <a 
              href="mailto:mradzwilla@gmail.com"
              className={`
                inline-block mr-2.5 ml-0.5 text-3xl transition-transform duration-300 align-top
                ${theme === 'dark' ? 'text-[#f7f7f7]' : 'text-[#3b3a36]'}
              `}
            >
              <FontAwesomeIcon icon={faEnvelope} alt="Send email" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}